import { useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as Close } from "../../../assets/close.svg";
import { useSelectedFilters } from "../../../hooks";
// import { fireCheckFilterEvent } from "../../customEvents";
import ActiveSelectedFilters from "./ActiveSelectedFilters";
import FiltersPannelButton from "./FiltersPannelButton";
import loadingGif from "./loading-3.gif";
import style from "./style.module.scss";

const StatusBar = ({ initialNbProducts, initialFilters }) => {
  const { selectedFilters } = useSelectedFilters(initialFilters);
  const [totalProducts, setTotalProducts] = useState(initialNbProducts);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const isMobile = useMediaQuery("(max-width: " + style.mobileBreakpoint + ")");
  // React i18next
  const { t } = useTranslation();

  // Reset all filters
  const resetUrl = window.location.href.replace(window.location.search, "");

  // Listen to the event "onSbmArchiveProductTotal".
  useEffect(() => {
    const callback = (e) => setTotalProducts(e.detail.total);
    document.addEventListener("onSbmArchiveProductTotal", callback);
    return () => {
      document.removeEventListener("onSbmArchiveProductTotal", callback);
    };
  }, []);

  return (
    <div className={style.statusBar}>
      {isMobile ? (
        <FiltersPannelButton />
      ) : (
        <ActiveSelectedFilters selectedFilters={selectedFilters} />
      )}

      <div className={style.result}>
        <div className={style.nbProducts}>
          {totalProducts} <b>{t("products found")}</b>
        </div>

        {!isMobile && (
          <a
            href={resetUrl}
            className={style.resetButton}
            onClick={() => setIsPageLoading(true)}
          >
            {isPageLoading ? (
              <img src={loadingGif} alt={`${t("Loading")}...`} loading="lazy" />
            ) : (
              <Close />
            )}
            <span>{t("Reset filters")}</span>
          </a>
        )}
      </div>
    </div>
  );
};

export default StatusBar;
